import { Variant } from '@blissbook/lib/expression'
import { immerable } from 'immer'
import { fromJSON, mapJSONValues } from './util/json'

export class Organization {
  id: number
  name: string
  subdomain: string
  blissbookOrigin: string
  origin: string
  createdAt: Date
  updatedAt: Date
  publishedAt: Date | null

  showPrivacyPolicy: boolean

  customSsoIdPeopleCount: number
  emailPeopleCount: number
  employeeIdPeopleCount: number
  friendsCount: number
  groupsCount: number
  hrbpsCount: number
  isHandbookPositionEnabled: boolean
  lastHiredOnPeopleCount: number
  managersCount: number
  membersCount: number
  preferredNamePeopleCount: number

  static get ATTRIBUTES() {
    return {
      createdAt: fromJSON.date,
      updatedAt: fromJSON.date,
      publishedAt: fromJSON.date,
    }
  }

  // Map attributes
  static mapJSON(json: object) {
    return mapJSONValues(json, Organization.ATTRIBUTES)
  }

  // Create a handbook from JSON
  static fromJSON(json: object) {
    return Object.assign(new Organization(), Organization.mapJSON(json))
  }

  // Variant
  static get variantType() {
    return 'organization' as const
  }
  get displayName() {
    return this.name
  }
  get uid() {
    return this.toVariant().uid
  }
  toVariant() {
    return new Variant(Organization.variantType, this.id)
  }
}

// @ts-ignore: immerable
Organization[immerable] = true

const weakMap = new WeakMap<object, Organization>()

/** Utility for converting JSON to a class */
export function toOrganization(json: object) {
  let organization = weakMap.get(json)
  if (!organization) {
    organization = Organization.fromJSON(json)
    weakMap.set(json, organization)
  }
  return organization
}
